export const isValidObject = (data) => {
    return data && Object.keys(data) && Object.keys(data)?.length > 0;
};